<video (ended)="onEnd()" autoplay id="video-background">
  <!-- <source src="assets/video/NSDA_Certification_Animated_Video.mp4" type="video/mp4" /> -->
</video>
